import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { type ContextEntityTargets } from 'contextMenus/getCommonMenuData';

interface ScrollToViewComponentPayload {
  componentId: ArdoqId;
}

export const scrollToViewComponent =
  actionCreator<ScrollToViewComponentPayload>(
    '[pagesView] SCROLL_TO_VIEW_COMPONENT'
  );

export type PagesViewContextMenuClickedPayload = {
  event: MouseEvent;
  targets: ContextEntityTargets;
  isViewpointMode: boolean;
};

export const pagesViewContextMenuClicked =
  actionCreator<PagesViewContextMenuClickedPayload>(
    '[pagesView] CONTEXT_MENU_CLICKED'
  );
